import PubSub from "underpub-js";
import slick from "slick-carousel";

var Callout = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-Callout',
  };

  $.extend(true, this.options, options);

};

Callout.prototype.init = function () {

  var self = this;

  self.$images = self.options.$el.find(`.${self.options.baseClass}__images`);
  self.$image = self.options.$el.find(`.${self.options.baseClass}__image`);
  self.$arrows = self.options.$el.find(`.${self.options.baseClass}__arrows`);
  self.$prevArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
  self.$nextArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

  if (self.$image.length > 1) {
    self.$arrows.show();

    self.$images.slick({
      prevArrow: self.$prevArrow,
      nextArrow: self.$nextArrow,
      swipe: true,
    });
  }

};

export default Callout;